import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { values } from 'd3';
import { TranslationService } from '@sdbn/common';
import { InhouseContact, Visit } from '../../../../tmc-visit.model';

@Component({
  selector: 'app-visit-visited',
  templateUrl: './visit-visited.component.html',
  styleUrls: ['./visit-visited.component.scss']
})
export class VisitVisitedComponent implements OnInit {

  visit: Visit;

  @Input('visit') set setVisit(value: Visit) {
    this.visit = value;
    this.patchVisitToForm(value);
    console.log('visit is set', this.visit);
  }

  formGroup = new FormGroup({});

  constructor(
    public translationService: TranslationService
  ) {

    this.formGroup.addControl('reason', new FormControl(null, []));
    this.formGroup.addControl('note', new FormControl(null, []));
    this.formGroup.addControl('name', new FormControl(null, []));
    this.formGroup.addControl('department', new FormControl(null, []));
    this.formGroup.addControl('phone', new FormControl(null, []));
    this.formGroup.addControl('mail', new FormControl(null, []));

    this.formGroup.valueChanges.subscribe(values => {
      this.visit.reason = values.reason;
      this.visit.notes = values.note;
      if (this.visit.visitedPerson == null) {
        this.visit.visitedPerson = new InhouseContact();
      }
      this.visit.visitedPerson.name = values.name;
      this.visit.visitedPerson.department = values.department;
      this.visit.visitedPerson.phone = values.phone;
      this.visit.visitedPerson.mail = values.mail;
    });

  }

  ngOnInit(): void {
    if (this.formGroup != null && this.visit != null) {
      this.patchVisitToForm(this.visit);
    }
  }

  patchVisitToForm(visit: Visit) {
    if (this.formGroup != null) {
      this.formGroup.patchValue({
        reason: visit.reason,
        note: visit.notes,
        name: visit.visitedPerson.name,
        department: visit.visitedPerson.department,
        phone: visit.visitedPerson.phone,
        mail: visit.visitedPerson.mail
      }, { emitEvent: false });
    }
  }

}
